import { Typography, Box, Table, TableBody } from 'components/ui';
import { FormattedMessage } from 'react-intl';
import { CardOptionTypography } from 'components/styles_components/typography';
import ShowItemTableRow from 'components/item/show_item_table_row';
import CreateButton from 'components/space/billing_details/button/create';
import EditButton from 'components/space/billing_details/button/edit';

const Show = ({ billingDetails, refetch }) => {
  if (!billingDetails) {
    return (
      <>
        <Typography variant="h6" gutterBottom>
          <FormattedMessage id="billing_details.title" />
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          <FormattedMessage id="billing_details.required_info" />
        </Typography>
        <Box display="flex" justifyContent="center">
          <CreateButton refetch={refetch} />
        </Box>
      </>
    );
  }

  return (
    <>
      <CardOptionTypography>
        <FormattedMessage id="billing_details.title" />
      </CardOptionTypography>
      <Table sx={{ mb: 2 }}>
        <TableBody>
          <ShowItemTableRow label={<FormattedMessage id="billing_details.name" />}>
            {billingDetails.name}
          </ShowItemTableRow>
          <ShowItemTableRow label={<FormattedMessage id="billing_details.address" />}>
            {billingDetails.address}
          </ShowItemTableRow>
          <ShowItemTableRow label={<FormattedMessage id="billing_details.zip_code" />}>
            {billingDetails.zipCode}
          </ShowItemTableRow>
          <ShowItemTableRow label={<FormattedMessage id="billing_details.city" />}>
            {billingDetails.city}
          </ShowItemTableRow>
          {billingDetails.taxId && (
            <ShowItemTableRow label={<FormattedMessage id="billing_details.tax_id" />}>
              {billingDetails.taxId}
            </ShowItemTableRow>
          )}
          <ShowItemTableRow label={<FormattedMessage id="billing_details.email" />}>
            {billingDetails.email}
          </ShowItemTableRow>
        </TableBody>
      </Table>
      <Box display="flex" justifyContent="center">
        <EditButton billingDetails={billingDetails} refetch={refetch} />
      </Box>
    </>
  );
};

export default Show;
